<template>
  <div>
    <el-date-picker
      type="week"
      size="mini"
      :style="'width: '+w"
      v-model="week"
      :format="start+' - '+end"
      :placeholder="placeholder"
      :picker-options="options"
      @change="changeWeek"
    ></el-date-picker>
  </div>
</template>
<script>
export default {
  props: {
    value: {},
    w: {
      type: String,
      default: "200px",
    },
    placeholder: {
      type: String,
      default: "选择星期",
    },
    sDate: {
      type: String,
      default: "",
    },
    eDate: {
      type: String,
      default: "",
    },
    //选中周的时候禁用的日期是否一起选中
    selectDisable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: {
        firstDayOfWeek: 1,
        disabledDate: this.disabledDate,
        cellClassName: this.cellClassName,
      },
      week: this.value ? new Date(this.value) : new Date(),
      start: "",
      end: "",
    };
  },
  mounted() {},
  methods: {
    init() {
      var weekday = this.week.getDay();
      var w_s = weekday == 0 ? 6 : weekday - 1; //获取一周的开始
      var w_e = weekday == 0 ? 0 : 7 - weekday; //获取一周的结束
      var s = this.$dayjs(this.week).subtract(w_s, "day").$d;
      var e = this.$dayjs(this.week).add(w_e, "day").$d;

      if (!this.selectDisable) {
        if (s < new Date(this.sDate)) s = this.sDate;
        if (e > new Date(this.eDate)) e = this.eDate;
      }

      this.start = this.$commonJs.toDateString(s);
      this.end = this.$commonJs.toDateString(e);
      this.$emit("change", { start: this.start, end: this.end });
    },
    disabledDate(value) {
      var old_s = this.sDate;
      var old_e = this.eDate;
      var weekday_s = new Date(old_s).getDay();
      var weekday_e = new Date(old_e).getDay();
      var new_s = this.$dayjs(old_s).subtract(weekday_s - 1, "day").$d;
      var new_e = this.$dayjs(old_e).add(7 - weekday_e, "day").$d;

      return value < new_s || value > new_e;
    },
    cellClassName(value) {
      value = this.$commonJs.toDateString(value);
      var s = this.sDate;
      var e = this.eDate;
      var new_s = this.$dayjs(s).subtract(1, "day").$d;
      var new_e = this.$dayjs(e).add(1, "day").$d;
      if (value < s || value > e) {
        return "normal disabled";
      }
    },
    changeWeek(data) {
      let startTime = this.$dayjs(data).subtract(1, "day").$d;
      let endTime = this.$dayjs(startTime).add(6, "day").$d;

      if (!this.selectDisable) {
        if (startTime < new Date(this.sDate)) startTime = this.sDate;
        if (endTime > new Date(this.eDate)) endTime = this.eDate;
      }

      this.start = this.$commonJs.toDateString(startTime);
      this.end = this.$commonJs.toDateString(endTime);

      this.$emit("change", { start: this.start, end: this.end });
    },
    // test() {
    //   var old_s = new Date(this.sDate);
    //   var old_e = new Date(this.eDate);
    //   var weekday_s = old_s.getDay();
    //   var weekday_e = old_e.getDay();
    //   var new_s = this.$dayjs(old_s).subtract(weekday_s - 1, "day").$d;
    //   var new_e = this.$dayjs(old_e).add(7 - weekday_e, "day").$d;

    //   console.log("学期开始", this.sDate);
    //   console.log("开始日期是星期几", weekday_s);
    //   console.log("学期结束", this.eDate);
    //   console.log("结束日期是星期几", weekday_e);
    //   console.log("开始日期所在周的周一", this.$commonJs.toDateString(new_s));
    //   console.log("结束日期所在周的周日", this.$commonJs.toDateString(new_e));
    // },
  },
};
</script>
<style lang="scss" scoped>
</style>